import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { Box } from './Box';
import styles from './Layout.module.scss';
export const Column = (_0)=>{
    let { className, children } = _0, rest = _object_without_properties(_0, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ _jsx(Box, _object_spread_props(_object_spread({
        className: cn(styles.column, className)
    }, rest), {
        children: children
    }));
};
